import {
  fetchAuthSession,
  signOut as amplifySignOut,
  getCurrentUser,
} from "@aws-amplify/auth";
import _ from "lodash";
import { resolveInventory, damageInventory } from "./damageActions";
import dvdlocator from "../../apis/dvdlocator";
import {
  FETCH_SESSION_LOG,
  ADD_INVENTORY,
  SUB_INVENTORY,
  MARK_INVENTORY,
  HOUSE_INVENTORY,
  SIGN_OUT,
  ADD_PRODUCT,
  ADD_PRODUCTS,
  DELETE_PRODUCT,
  GET_USER_TOKEN,
  FETCH_TOTALS,
  FETCH_WEEKLY_INVENTORY,
  ONO_INVENTORY,
  SUPPLIER_INVENTORY,
} from "./types";
import { setSubRefreshQuantity } from "./subActions";

export { resolveInventory, damageInventory };

export const addProduct = (formValues) => {
  return {
    type: ADD_PRODUCT,
    payload: formValues,
  };
};

export const addProducts = (products) => {
  return {
    type: ADD_PRODUCTS,
    payload: products,
  };
};

export const deleteProduct = (id) => {
  return {
    type: DELETE_PRODUCT,
    payload: id,
  };
};

export const fetchInventoryLog = (date) => async (dispatch) => {
  let uri = "/nosql/session-log";
  if (date) uri = uri + `?date=${date}`;
  const response = await dvdlocator.get(uri);

  return dispatch({
    type: FETCH_SESSION_LOG,
    payload: response.data,
  });
};

export const fetchWeeklyInventoryLog = () => async (dispatch) => {
  const response = await dvdlocator.get("/nosql/weekly-session-log");

  return dispatch({
    type: FETCH_WEEKLY_INVENTORY,
    payload: response.data,
  });
};

export const fetchTotals = () => async (dispatch) => {
  const response = await dvdlocator.get("/totals");

  return dispatch({
    type: FETCH_TOTALS,
    payload: response.data,
  });
};

export const updateONO = () => async (dispatch, getState) => {
  const products = _.without(getState().products, undefined);
  console.log(products);

  const requestBody = { orders: products };

  const response = await dvdlocator.post("/inventory/update-ono", requestBody);

  const body = response.data;
  const { userId } = getState().auth;

  body.forEach((element) => {
    element.userId = userId;
  });

  const sessionLogBody = {
    items: body,
  };

  const newSessionLog = {};
  newSessionLog.items = sessionLogBody.items.filter((row) => row);
  await dvdlocator.put("/nosql/session-log", newSessionLog);

  return dispatch({
    type: ONO_INVENTORY,
    payload: body,
  });
};

export const supplierData = () => async (dispatch, getState) => {
  const products = _.without(getState().products, undefined);
  console.log(products);

  const requestBody = { orders: products };

  const response = await dvdlocator.post(
    "/inventory/supplier-data",
    requestBody
  );

  const body = response.data;
  const { userId } = getState().auth;

  body.forEach((element) => {
    element.userId = userId;
  });

  const sessionLogBody = {
    items: body,
  };

  const newSessionLog = {};
  newSessionLog.items = sessionLogBody.items.filter((row) => row);
  await dvdlocator.put("/nosql/session-log", newSessionLog);

  return dispatch({
    type: SUPPLIER_INVENTORY,
    payload: body,
  });
};

export const addInventory = () => async (dispatch, getState) => {
  const products = _.without(getState().products, undefined);
  console.log(products);

  const requestBody = { units: products };

  const response = await dvdlocator.post("/inventory/add", requestBody);

  const body = response.data;
  const { userId } = getState().auth;

  body.forEach((element) => {
    element.userId = userId;
  });

  const sessionLogBody = {
    items: body,
  };

  const newSessionLog = {};
  newSessionLog.items = sessionLogBody.items.filter((row) => row);
  await dvdlocator.put("/nosql/session-log", newSessionLog);

  return dispatch({
    type: ADD_INVENTORY,
    payload: body,
  });
};

export const subInventory = () => async (dispatch, getState) => {
  const products = _.without(getState().products, undefined);
  console.log(products);

  const requestBody = { units: products };

  const response = await dvdlocator.post("/inventory/sub", requestBody);

  dispatch(setSubRefreshQuantity(true));

  const body = response.data;
  const { userId } = getState().auth;

  body.forEach((element) => {
    element.userId = userId;
  });

  const sessionLogBody = {
    items: body,
  };
  const newSessionLog = {};
  newSessionLog.items = sessionLogBody.items.filter((row) => row);

  await dvdlocator.put("/nosql/session-log", newSessionLog);

  return dispatch({
    type: SUB_INVENTORY,
    payload: body,
  });
};

export const markListing = () => async (dispatch, getState) => {
  // remove undefineds
  const products = _.without(getState().products, undefined);

  // make a list of mskus from state
  const mskus = _.map(products, (product) => {
    return product.MSKU;
  });

  const markers = _.map(products, (product) => {
    if (product.marker) {
      return product.marker;
    }
    return "";
  });

  const marking_columns = _.map(products, (product) => {
    return product.markingColumn;
  });

  const requestBody = { mskus, markers, marking_columns };

  const response = await dvdlocator.post("/product/mark", requestBody);

  const body = response.data;
  const { userId } = getState().auth;

  body.forEach((element) => {
    element.userId = userId;
  });

  const sessionLogBody = {
    items: body,
  };

  const newSessionLog = {};
  newSessionLog.items = sessionLogBody.items.filter((row) => row);

  await dvdlocator.put("/nosql/session-log", newSessionLog);

  return dispatch({
    type: MARK_INVENTORY,
    payload: body,
  });
};

export const markInventory = () => async (dispatch, getState) => {
  // remove undefineds
  const products = _.without(getState().products, undefined);

  // make a list of upcs from state
  const upcs = _.map(products, (product) => {
    return product.UPC;
  });

  const markers = _.map(products, (product) => {
    if (product.marker) {
      return product.marker;
    }
    return "";
  });

  const marking_columns = _.map(products, (product) => {
    return product.markingColumn;
  });

  const requestBody = { upcs, markers, marking_columns };

  const response = await dvdlocator.post("/inventory/mark", requestBody);

  const body = response.data;
  const { userId } = getState().auth;

  body.forEach((element) => {
    element.userId = userId;
  });

  const sessionLogBody = {
    items: body,
  };

  const newSessionLog = {};
  newSessionLog.items = sessionLogBody.items.filter((row) => row);

  await dvdlocator.put("/nosql/session-log", newSessionLog);

  return dispatch({
    type: MARK_INVENTORY,
    payload: body,
  });
};

export const houseInventory = () => async (dispatch, getState) => {
  // remove undefineds
  const products = _.without(getState().products, undefined);

  // make a list of upcs from state and remove undefineds
  const upcs = _.map(products, (product) => {
    return product.UPC;
  });

  const override_order_nums = _.map(products, (product) => {
    if (!product.override) {
      return false;
    }
    return product.override;
  });
  const order_nums = _.map(products, (product) => {
    return product.orderNumber;
  });
  const supplier_order_nums = _.map(products, (product) => {
    return product.supplierOrderNumber;
  });
  const suppliers = _.map(products, (product) => {
    return product.supplier;
  });
  const ordered_by = _.map(products, (product) => {
    return product.orderedBy;
  });
  const prices = _.map(products, (product) => {
    return product.price;
  });
  const quantities = _.map(products, (product) => {
    return product.amount;
  });

  const requestBody = {
    upcs,
    override_order_nums,
    order_nums,
    supplier_order_nums,
    suppliers,
    ordered_by,
    prices,
    quantities,
  };

  const response = await dvdlocator.post("/inventory/house", requestBody);

  const body = response.data;
  const { userId } = getState().auth;

  body.forEach((element) => {
    element.userId = userId;
  });

  const sessionLogBody = {
    items: body,
  };

  const newSessionLog = {};
  newSessionLog.items = sessionLogBody.items.filter((row) => row);
  await dvdlocator.put("/nosql/session-log", newSessionLog);

  return dispatch({
    type: HOUSE_INVENTORY,
    payload: body,
  });
};

// Updated function to load user token using Amplify v6
export const getUserToken = () => async (dispatch) => {
  try {
    // Get current session and user info
    const session = await fetchAuthSession();
    const user = await getCurrentUser();

    // Extract user email and create userId
    const userEmail = user.signInDetails?.loginId || user.username;
    const userId = userEmail?.split("@")[0];

    if (!session.tokens || !userId) {
      throw new Error("Unable to get valid session or user ID");
    }

    dispatch({
      type: GET_USER_TOKEN,
      payload: {
        idToken: session.tokens.idToken?.toString(),
        userId: userId,
      },
    });
  } catch (error) {
    console.error("Error getting user token:", error);
    throw error;
  }
};

// Updated sign out function using Amplify v6
export const signOut = () => async (dispatch) => {
  try {
    await amplifySignOut();
    dispatch({
      type: SIGN_OUT,
    });
  } catch (error) {
    console.error("Error signing out:", error);
    throw error;
  }
};
